import { render, staticRenderFns } from "./DepartmentLov.vue?vue&type=template&id=f586b7b6&"
import script from "./DepartmentLov.vue?vue&type=script&lang=js&"
export * from "./DepartmentLov.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports